import { FC, MouseEvent, ReactNode, forwardRef } from "react";
import { Dropdown } from "react-bootstrap";
import { ThreeDotsVertical } from "react-bootstrap-icons";

interface CustomToggleProps {
  onClick: (e: MouseEvent<HTMLAnchorElement>) => void;
}

const CustomToggle = forwardRef<HTMLAnchorElement, CustomToggleProps>(({ onClick }, ref) => (
  <a
    href=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    role="button"
  >
    <ThreeDotsVertical />
  </a>
));

interface ActionMenuProps {
  children?: ReactNode[];
}

export const ActionMenu: FC<ActionMenuProps> = ({ children }) => {
  return (
    <Dropdown align="start">
      <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components" />
      <Dropdown.Menu>{children}</Dropdown.Menu>
    </Dropdown>
  );
};
